"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeOptions = exports.validationConfig = exports.initialMediaAssetValues = exports.columns = exports.INITIAL_VISIBLE_COLUMNS = exports.LayoutType = void 0;
var LayoutType;
(function (LayoutType) {
    LayoutType["LIST"] = "LIST";
    LayoutType["GRID"] = "GRID";
})(LayoutType = exports.LayoutType || (exports.LayoutType = {}));
exports.INITIAL_VISIBLE_COLUMNS = ["file_name", "file_type", "file_size", "uploaded_by", "product_count", "actions"];
exports.columns = [
    { name: "File", uid: "url", sortable: true },
    { name: "File Name", uid: "file_name", sortable: true },
    { name: "Type", uid: "file_type", sortable: true },
    { name: "Size", uid: "file_size", sortable: true },
    { name: "Products", uid: "product_count", sortable: false },
    { name: "Uploaded By", uid: "metadata.author", sortable: true },
    { name: "Actions", uid: "actions", sortable: false },
];
exports.initialMediaAssetValues = {
    url: "",
    etag: "",
    file_name: "",
    file_type: "",
    file_size: 0,
    uploaded_by: "",
    metadata: {
        title: "",
        description: "",
        alt_text: "",
        copyright: "",
        width: 0,
        height: 0,
        color_space: "",
        duration: 0,
        fps: 0,
        page_count: 0,
        author: "",
        format: "",
    },
};
exports.validationConfig = {
    file_name: { required: true, maxLength: 255 },
    file_type: { required: true },
    file_size: { required: true, min: 0 },
    metadata: {
        title: { required: false, maxLength: 255 },
        description: { required: false, maxLength: 1000 },
        alt_text: { required: false, maxLength: 255 },
        copyright: { required: false, maxLength: 255 },
        width: { required: false, min: 0 },
        height: { required: false, min: 0 },
        color_space: { required: false },
        duration: { required: false, min: 0 },
        fps: { required: false, min: 0 },
        page_count: { required: false, min: 0 },
        author: { required: false, maxLength: 255 },
        format: { required: false },
    },
};
exports.typeOptions = [
    { value: "", label: "All Types" },
    { value: "IMAGE", label: "Image" },
    { value: "VIDEO", label: "Video" },
    { value: "DOCUMENT", label: "Document" },
];
